import Logo from "../../assets/images/Logo.svg";
import LogoSmall from "../../assets/images/LogoSmall.svg";
import ActiveHome from "../../assets/images/sidebar/active/Home.svg";
import InactiveHome from "../../assets/images/sidebar/inactive/Home.svg";
import ActiveReports from "../../assets/images/sidebar/active/Reports.svg";
import InactiveReports from "../../assets/images/sidebar/inactive/Reports.svg";
import ActiveDoctors from "../../assets/images/sidebar/active/Doctors.svg";
import InactiveDoctors from "../../assets/images/sidebar/inactive/Doctors.svg";
import ActiveUsers from "../../assets/images/sidebar/active/Users.svg";
import InactiveUsers from "../../assets/images/sidebar/inactive/Users.svg";
import ActiveTemplates from "../../assets/images/sidebar/active/Templates.svg";
import InactiveTemplates from "../../assets/images/sidebar/inactive/Templates.svg";
import ActiveAnalytics from "../../assets/images/sidebar/active/Analytics.svg";
import InactiveAnalytics from "../../assets/images/sidebar/inactive/Analytics.svg";
import ActiveSettings from "../../assets/images/sidebar/active/Settings.svg";
import InactiveSettings from "../../assets/images/sidebar/inactive/Settings.svg";
import ActiveNotification from "../../assets/images/sidebar/active/Notification.svg";
import InactiveNotification from "../../assets/images/sidebar/inactive/Notification.svg";
import InactiveKnowledgeBase from "../../assets/images/sidebar/inactive/KnowledgeBase.svg";
import ActiveKnowledgeBase from "../../assets/images/sidebar/active/KnowledgeBase.svg";
import InactiveSearch from "../../assets/images/sidebar/inactive/Search.svg";
import InactiveOpen from "../../assets/images/sidebar/inactive/Open.svg";
import ActiveSearch from "../../assets/images/sidebar/active/Search.svg";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import LogoutIcon from "../../assets/images/Logout.svg";
import { getCurrentDimension, isInRole, removeTokens, separateRoles } from "../../helpers/HelperFunctions";
import { FirebaseUser, User } from "../../store/Store";
import ApiService from "../../services/ApiService";
import Loading from "../Loading/Loading";
import ProfileImageLoader from "../ProfileImageLoader/ProfileImageLoader";
import { firebaseSignOut } from "../../helpers/FirebaseFunctions";
import { INotification } from "../../helpers/Interfaces";

import "./SideBar.scss";

type SidebarProps = {
    selectedIndex: number
}

export default function SideBar(props: Readonly<SidebarProps>) {
    let screenWidth = getCurrentDimension().width

    const apiService = new ApiService();

    const [loading, setLoading] = useState(false);

    const [user] = useContext(User);
    const [firebaseUser] = useContext(FirebaseUser);

    const navigate = useNavigate();

    function getNewNotificationsCount() {
        let newNotifications: INotification[] = firebaseUser?.notifications?.filter((notification: INotification) => {
            return !notification?.read
        });

        return newNotifications?.length;
    }

    function handleLogout() {

        setLoading(true);

        apiService.logout().finally(async () => {
            removeTokens();
            await firebaseSignOut();
            navigate("/login");
            setLoading(false);
        });
    }

    return (<div className="side-bar-container">
        <img className="logo" src={Logo} alt={"Logo"} />
        <img className="logo-small" src={LogoSmall} alt={"Logo"} />

        <div className="nav-link-container">
            {isInRole(user?.roles, "Admin")
                ? (<Link className={`nav-link ${(screenWidth > 425 && props.selectedIndex === 0) ? "active" : ""}`} to={"/dashboard/home"}>
                    <img className="nav-img" src={(screenWidth > 425 && props.selectedIndex === 0) ? ActiveHome : InactiveHome} alt={"Home"} />
                    <span className={`text ${(screenWidth > 425 && props.selectedIndex === 0) ? "active" : ""}`}>Home</span>
                </Link>)
                : (<></>)
            }

            <Link className={`nav-link ${(props.selectedIndex === 1) ? "active" : ""}`} to={"/dashboard/reports"}>
                <img className="nav-img" src={props.selectedIndex === 1 ? ActiveReports : InactiveReports} alt={"Reports"} />
                <span className={`text ${(props.selectedIndex === 1) ? "active" : ""}`}>Reports</span>
            </Link>

            {isInRole(user?.roles, "Admin")
                ? (<Link className={`nav-link ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 9) ? "active" : ""}`} to={"/dashboard/search"}>
                    <img className="nav-img" src={(isInRole(user?.roles, "Admin") && props.selectedIndex === 9) ? ActiveSearch : InactiveSearch} alt={"Reports"} />
                    <span className={`text ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 9) ? "active" : ""}`}>Search</span>
                </Link>)
                : (<></>)
            }

            {isInRole(user?.roles, "Admin")
                ? (<Link className={`nav-link ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 2) ? "active" : ""}`} to={"/dashboard/doctors"}>
                    <img className="nav-img" src={(isInRole(user?.roles, "Admin") && props.selectedIndex === 2) ? ActiveDoctors : InactiveDoctors} alt={"Doctors"} />
                    <span className={`text  ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 2) ? "active" : ""}`}>Doctors</span>
                </Link>)
                : (<></>)
            }

            {isInRole(user?.roles, "Admin")
                ? (<Link className={`nav-link ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 3) ? "active" : ""}`} to={"/dashboard/users"}>
                    <img className="nav-img" src={(isInRole(user?.roles, "Admin") && props.selectedIndex === 3) ? ActiveUsers : InactiveUsers} alt={"Users"} />
                    <span className={`text ${(isInRole(user?.roles, "Admin") && props.selectedIndex === 3) ? "active" : ""}`}>List of Users</span>
                </Link>)
                : (<></>)
            }

            <Link className={`nav-link ${props.selectedIndex === 4 ? "active" : ""}`} to={"/dashboard/templates"}>
                <img className="nav-img" src={props.selectedIndex === 4 ? ActiveTemplates : InactiveTemplates} alt={"Templates"} />
                <span className={`text ${props.selectedIndex === 4 ? "active" : ""}`}>Templates</span>
            </Link>

            {isInRole(user?.roles, "Admin")
                ? (<Link className={`nav-link ${(isInRole(user?.roles, "Admin") && screenWidth > 425 && props.selectedIndex === 5) ? "active" : ""}`} to={"/dashboard/analytics"}>
                    <img className="nav-img"
                        src={(isInRole(user?.roles, "Admin") && screenWidth > 425 && props.selectedIndex === 5)
                            ? ActiveAnalytics
                            : InactiveAnalytics}
                        alt={"Analytics"} />
                    <span className={`text ${(isInRole(user?.roles, "Admin") && screenWidth > 425 && props.selectedIndex === 5) ? "active" : ""}`}>Analytics</span>
                </Link>)
                : (<></>)
            }

            <Link className={`nav-link ${props.selectedIndex === 6 ? "active" : ""}`} to={"/dashboard/domain"}>
                <img className="nav-img" src={props.selectedIndex === 6 ? ActiveKnowledgeBase : InactiveKnowledgeBase} alt={"domain"} />
                <span className={`text ${props.selectedIndex === 6 ? "active" : ""}`}>Knowledge Base</span>
            </Link>

            <Link className={`nav-link ${props.selectedIndex === 7 ? "active" : ""}`} to={"/dashboard/settings"}>
                <img className="nav-img" src={props.selectedIndex === 7 ? ActiveSettings : InactiveSettings} alt={"Settings"} />
                <span className={`text ${props.selectedIndex === 7 ? "active" : ""}`}>Settings</span>
            </Link>

            <div className={`nav-link`} onClick={() => { window.open("https://scribeon.ai/", "_blank") }}>
                <img className="nav-img" src={InactiveOpen} alt={"Open"} />
                <span className={`text`}>ScribeOn AI</span>
            </div>

            <Link className={`notification-link-wrapper ${props.selectedIndex === 8 ? "active" : ""}`} to={"/dashboard/notifications"}>
                <img className="notification-img" src={props.selectedIndex === 8 ? ActiveNotification : InactiveNotification} alt={"Notifications"} />
                <span className="notification-text">Notifications
                    {getNewNotificationsCount() > 0
                        ? (<span className="count">{getNewNotificationsCount()}</span>)
                        : (<></>)
                    }
                </span>
            </Link>
        </div>
        <div className="profile">
            <span className="profile-text">Profile</span>
            <div className="image-text">
                <Link className="nav-text" to={"/dashboard/settings"}>
                    <ProfileImageLoader name={user?.firstName + " " + user?.lastName}
                        imageUrl={user?.profileImageUrl} style={"nav-img"} />
                </Link>
                <div className="text">
                    <span className="name">{user?.firstName}</span>
                    <span className="role">{separateRoles(user?.roles)}</span>
                </div>
            </div>
            <Link className="logout" to="#" onClick={() => { handleLogout() }}>
                {loading
                    ? (<Loading color="black" />)
                    : (<>
                        <img className="logout-img" src={LogoutIcon} alt={"Logout"} />
                        <span className="logout-text">Logout</span>
                    </>)
                }
            </Link>
        </div>
    </div >)
}